import {BUTTON_LABELS} from '@github-ui/issue-viewer/ButtonLabels'
import {AlertFillIcon, type Icon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {clsx} from 'clsx'
import type {FC} from 'react'

import styles from './ListError.module.css'

export type ListErrorProps = {
  title: string
  message: string
  retry?: () => void
  icon?: Icon
  retryText?: string
  testid?: string
}

export const ListError: FC<ListErrorProps> = ({retry, icon, title, message, retryText, testid}) => {
  const IconComponent = icon ?? AlertFillIcon

  return (
    <div className="blankslate" data-testid={testid}>
      <IconComponent className={clsx('blankslate-icon', styles.errorIcon)} />
      <h3 className="blankslate-heading">{title}</h3>
      <p className={styles.errorMessage}>{message}</p>
      {retry && (
        <Link as="button" inline onClick={retry} className={styles.retryLink}>
          {retryText ?? BUTTON_LABELS.tryAgain}
        </Link>
      )}
    </div>
  )
}
